import React, { useEffect, useState } from "react";
import zxcvbn from "zxcvbn";
import './passwordStrengthIndicator.css';
import Indicators from "./StrengthIndicators"

const PasswordStrengthIndicator = (props) => {
  const [indicator, setIndicator] = useState();

  useEffect(() => {
    if (props.password === "") return;

    setIndicator(zxcvbn(props.password));
  }, [props.password]);

  const score = indicator ? indicator.score : -1;

  return (
    <div className="d-block mx-4">
      <div className="position-relative mt-3">
        {props.password !== "" && <Indicators score={score} />}
      </div>
    </div>
  );
};

export default PasswordStrengthIndicator;
